import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { useLocation, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { ApproveData, RejectData, HoldData } from '../reduxactions/adminactions/AViewHospitalActions';
import { RootState } from '../reducers';
import { Dialog } from 'primereact/dialog';

export const AdminViewhospital = () => {

  const location = useLocation();
  const [globalFilter, setGlobalFilter] = useState('');
  const stepperRef = useRef(null);


  const [queryParams, setQueryParams] = useState(null);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("SupervisorID") as any);
  }, [location]);
  const { SupervisorID } = useParams();


  const [hospital, setHospital] = useState<[]>([]);
  const getdata = async () => {
    try {
      const payload = { q: 3, asid: SupervisorID };
      const apiname = Admin_API.Hospital_API;
      const data = await LoginService.getData(apiname, payload);
      setHospital(data);
    } catch (error) {

    }
  };
  const datareject = useSelector((state: RootState) => state.viewhospital.datareject);
  const toast = useRef(datareject);


  const reject = async () => {
    try {
      await dispatch(RejectData(SupervisorID) as any);
      toast.current.show({ severity: 'error', summary: 'Hospital Rejected Successfully', life: 3000 });

      getdata()
    } catch (error) {
      console.error('Error fetching data:', error);
    }

  };


  const dispatch = useDispatch();

  const dataapprove = useSelector((state: RootState) => state.viewhospital.dataapprove);
  const toast1 = useRef(dataapprove);


  const approve = async () => {
    try {
      await dispatch(ApproveData(SupervisorID) as any);
      toast1.current.show({ severity: 'success', summary: 'User Approved Successfully', life: 3000 });
      getdata()
    } catch (error) {
      console.error('Error fetching data:', error);
    }

  };
  const dataahold = useSelector((state: RootState) => state.viewhospital.datahold);
  const toast2 = useRef(dataahold);
  const hold = async () => {
    try {
      await dispatch(HoldData(SupervisorID) as any);
      toast2.current.show({ severity: 'error', summary: 'User Hold  Successfully', life: 3000 });
      getdata()

    } catch (error) {
      console.error('Error fetching data:', error);
    }


  };
  const [uplodata, setuplodata] = useState<[]>([]);


  const getuploddata = async () => {
    try {
      const payload = { uid: SupervisorID };
      const apiname = Admin_API.upload_API;
      const data1 = await LoginService.getData(apiname, payload);
      setuplodata(data1);
    } catch (error) {

    }
  };
  const [ViewDilog, setViewDilog] = useState(false);

  const viewPage = (rowData: any) => {


    setViewDilog(true);
  }









  useEffectOnce(() => {
    getdata()
    getuploddata()

  }, []);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/viewhospitallist.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div>
      <div className="admin-layout-container" style={{ marginTop: '60px' }}>
        {hospital.map((response: any) => (
          <div className="grid">
            <div className="col-2"></div>
            <div className="col-8">
              <section className="content" >
                <div className="col-16" style={{ textAlign: "right" }}>
                  <a
                    title="help"
                    onClick={(e) => openWindow(e, IUrl)}
                    style={{

                      color: "blue",
                      fontSize: 15, cursor: "pointer"
                    }}
                  >Help for this Page &nbsp;
                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                  </a>
                </div>
                <Card title="" style={{ width: '120%', padding: '0.4rem' }}>
                  <Panel header="Hospital Name" style={{ width: '100%', padding: '0.6rem 0' }} toggleable>
                    <div className="grid" >

                      <div className="col-12 md:col-12 lg:col-5" style={{ marginLeft: '40px' }}>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Hospital Name :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hospitalname}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Hospital Prefix :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.hospitalprefix}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Email :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.email}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Phone No:</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.phone}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Address :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px', textAlign: 'start', width: '150px' }}>{response.address}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>City :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.scity}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>State :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.statename}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Country :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.CountryName}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Status :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.status}</p>
                        </div>
                      </div>

                      <div className="col-12 md:col-12 lg:col-5" style={{ marginLeft: '40px' }}>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Supervisor Name :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.sfname || response.slname}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Email :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.email}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Address :</strong>
                          {/* <p className="text-muted" style={{ marginLeft: '10px' }}>{response.saddress}</p> */}
                          <p className="text-muted" style={{ marginLeft: '10px', textAlign: 'start', width: '180px' }}>{response.saddress}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Phone :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.sphone}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>City :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.scity}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>State :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.sstatename}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Country :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.CountryName}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ width: '150px', textAlign: 'start' }}>Status :</strong>
                          <p className="text-muted" style={{ marginLeft: '10px' }}>{response.status}</p>
                        </div>
                      </div>

                    </div>
                  </Panel>
                  <div className='grid'>
                    <div className='col-8'></div>
                    <div className='col-4' style={{ marginTop: '10px' }}>
                      {hospital.map((response: any) => (
                        response.sstatus === 'REJECTED' && (
                          <Button className='mr-1' severity="success" label="Approve" rounded onClick={approve} />
                        )

                      ))}
                      {hospital.map((response: any) => (
                        response.sstatus === 'APPLIED' && (
                          <Button className='mr-1' severity="success" label="Approve" rounded onClick={approve} />
                        )

                      ))}
                      {hospital.map((response: any) => (
                        response.sstatus === 'HOLD' && (
                          <Button className='mr-1' severity="success" label="Approve" rounded onClick={approve} />
                        )

                      ))}


                      {hospital.map((response: any) => (
                        response.sstatus === 'APPLIED' && (
                          <Button className='mr-1' severity="danger" label="Reject" rounded onClick={reject} />
                        )

                      ))}
                      {hospital.map((response: any) => (
                        response.sstatus === 'HOLD' && (
                          <Button className='mr-1' severity="danger" label="Reject" rounded onClick={reject} />
                        )

                      ))}

                      {hospital.map((response: any) => (
                        response.sstatus === 'APPROVED' && (
                          <Button className='mr-1' severity="danger" label="Reject" rounded onClick={reject} />
                        )

                      ))}



                      {hospital.map((response: any) => (
                        response.sstatus === 'APPLIED' && (
                          // <Button className='mr-1' severity="danger" label="Reject" rounded onClick={() => rejectVolunteers()} />
                          <Button className='mr-1' severity="danger" label="HOLD" rounded onClick={hold} />

                        )


                      ))}
                    </div>
                  </div>

                </Card>
              </section>
            </div>
          </div>
        ))}
        <section className="content">
          <div className="grid">
            <div className="col-2"></div>
            <div className="col-8">
              <div className="card card-primary">
                <Card title="" style={{ width: '120%' }}>
                  <Panel header="View Documents" style={{ width: '100%' }} toggleable>

                    <div className="card card-primary">
                      <div className="card flex flex-wrap justify-content">
                      </div>
                      <DataTable value={uplodata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                        <Column field="docname" sortable header="Document Title"></Column>
                        <Column header="Operation" body={(rowData) => (
                          <>
                            {/* <Button rounded outlined className='mr-3' tooltip="Edit" icon="pi pi-eye" style={{ backgroundColor: 'white', color: 'seagreen' }} /> */}
                            <Button className='mr-1' tooltip="View" severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewPage(rowData)} />
                          </>
                        )} />
                      </DataTable>
                    </div>
                  </Panel>
                </Card>
              </div>

            </div>
            <div className="col-1"></div>
          </div>
        </section>
        <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
          <div className="modal-header">
          </div>
          <div className="modal-body">
            {uplodata.map((response: any, index: number) =>
              <div key={index}>
                <img src={response.image} alt="Doc" width="100%" height="auto" />
              </div>
            )}
          </div>
        </Dialog>




      </div>




      <Toast ref={toast} >
        <Message severity="error" content={datareject} />
      </Toast>

      <Toast ref={toast1} >
        <Message severity="success" content={dataapprove} />
      </Toast>
      <Toast ref={toast2} >
        <Message severity="error" content={dataahold} />
      </Toast>




    </div>
  )
}
